<template>
<div>

    <v-form ref="form" lazy-validation>
        <v-card class="ma-2">
            <v-card-title class="teal white--text"> Data Pribadi </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-row> <v-col> <v-text-field label="Nama" v-model="form.nama" outlined :rules="[rules.required]" :readonly="readonly" /> </v-col> </v-row>
                            <v-row> <v-col> <v-text-field label="Alamat" v-model="form.alamat" outlined :rules="[rules.required, v => v.length <= 200 || 'Max 200 characters']" :readonly="readonly" /> </v-col> </v-row>
                            <v-row> 
                                <v-col> 
                                    <v-text-field v-if="readonly" label="Provinsi" v-model="form.provinsi" outlined readonly />
                                    <v-select v-else label="Provinsi" v-model="form.provinsi" :items="listProvinsi" outlined @change="provinsiChange()" :rules="[rules.required]" /> 
                                </v-col> 
                            </v-row>
                            <v-row> 
                                <v-col> 
                                    <v-text-field v-if="readonly" label="Kabupaten / Kota" v-model="form.kabkod" outlined readonly />
                                    <v-select v-else label="Kabupaten / Kota" v-model="form.kabkod" :items="listKabKota" outlined :rules="[rules.required]" /> 
                                </v-col> 
                            </v-row>
                            <v-row> <v-col> <v-text-field label="Kode Pos" v-model="form.kodepos" type="number" outlined :rules="[rules.required, v => v.length == 5 || 'Kodepos harus 5 digit']" :readonly="readonly" /> </v-col> </v-row>
                        </v-col>
                        <v-col>
                            <v-row> <v-col> <v-text-field label="No. Telp/HP" v-model="form.telepon" outlined :rules="[rules.required]" :readonly="readonly" /> </v-col> </v-row>
                            <v-row> <v-col> <v-text-field label="E-Mail" v-model="form.email" outlined :readonly="readonly" /> </v-col> </v-row>
                            <v-row> <v-col> <v-text-field label="No. KTP" v-model="form.noKtp" outlined :rules="[rules.required]" :readonly="readonly" /> </v-col> </v-row>
                            <v-row> <v-col> <v-text-field label="No. NPWP" v-model="form.npwp" v-mask="'##.###.###.#-###.###'" placeholder="00.000.000.0-000.000" outlined :rules="[rules.required]" :readonly="readonly" /> </v-col> </v-row>
                        </v-col>
                    </v-row>

                    <v-row> 
                        <v-col> 
                            <v-text-field v-if="readonly" label="File KTP" v-model="form.fileKtp" readonly >
                                <template v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileKtp)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-text-field>
                            <v-file-input v-else
                                label="File KTP" 
                                v-model="form.uploadFileKtp" 
                                :placeholder="form.fileKtp" 
                                accept=".jpg,.png,.pdf" 
                                :rules="[validateFileKtp()]"
                            >
                                <template v-if="form.fileKtp !== ''" v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileKtp)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-file-input>
                        </v-col> 
                        <v-col> 
                            <v-text-field v-if="readonly" label="File NPWP" v-model="form.fileNpwp" readonly >
                                <template v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileNpwp)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-text-field>
                            <v-file-input v-else
                                label="File NPWP" 
                                v-model="form.uploadFileNpwp" 
                                :placeholder="form.fileNpwp" 
                                accept=".jpg,.png,.pdf" 
                                :rules="[validateFileNpwp()]"
                            >
                                <template v-if="form.fileNpwp !== ''" v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileNpwp)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-file-input>
                        </v-col> 
                    </v-row>

                    <v-row> 
                        <v-col cols="6"> 
                            <v-text-field v-if="readonly" label="File Formulir Keikutsertaan" v-model="form.fileFormulir" readonly >
                                <template v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileFormulir)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-text-field>
                            <v-file-input v-else
                                label="File Formulir Keikutsertaan" 
                                v-model="form.uploadFileFormulir" 
                                :placeholder="form.fileFormulir" 
                                accept=".jpg,.png,.pd,.doc,.docx" 
                                :rules="[validateFileFormulir()]"
                            >
                                <template v-if="form.fileFormulir !== ''" v-slot:append>
                                    <v-btn icon @click="getLinkDownload(form.fileFormulir)"><v-icon color="green">get_app</v-icon></v-btn>
                                </template>
                            </v-file-input>
                        </v-col> 
                    </v-row>

                </v-container>
            </v-card-text>

            <v-card-text v-if="!readonly">
                <v-btn class="green" @click="submit()" dark>Simpan</v-btn>
            </v-card-text>
        </v-card>
    </v-form>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{ notification.text }}
    </v-snackbar>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>
    
    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>    
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'
import { provinsi, daerah } from "./../../lib/viewLib"


export default {
    props: {
        readonly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            listProvinsi: provinsi,
            listKabKota: [],

            rules: {
                required: Rules.required,
                email: Rules.email,
            },

            form: {
                nama: "",
                alamat: "",
                kodepos: "",
                provinsi: "",
                kabkod: "",
                telepon: "",
                email: "",
                noKtp: "",
                fileKtp: "",
                npwp: "",
                fileNpwp: "",
                fileFormulir: "",
                uploadFileKtp: null,
                uploadFileNpwp: null,
                uploadFileFormulir: null,
            },

            notification: {
                show: false,
                color: "success",
                text: ""
            },

            submitting: false,
            loginExpired:  false
        }
    },


    computed: {
        vendorId() {
            return this.$store.getters['ven/venId'];
        },

    }, // computed


    watch: {
        vendorId() {
            this.getData();
        }
    },


    mounted() {
        this.getData();
    }, // mounted


    methods: {
        getData() {
            axios.get(`${apiUrl}/vendor/person/data-pribadi/${this.vendorId}`)
            .then( (response) => {
                //console.log("PersonDataPribadi.created() response: ", response.data);

                if (response.data) {
                    this.form.nama = response.data.nama;
                    this.form.alamat = response.data.alamat;
                    this.form.provinsi = response.data.provinsi;
                    this.provinsiChange();
                    this.form.kabkod = response.data.kabkod;
                    this.form.kodepos = response.data.kodepos;
                    this.form.telepon = response.data.telepon;
                    this.form.email = response.data.email;
                    this.form.noKtp = response.data.noKtp;
                    this.form.npwp = response.data.npwp;
                    this.form.fileKtp = response.data.fileKtp;
                    this.form.fileNpwp = response.data.fileNpwp;
                    this.form.fileFormulir = response.data.fileFormulir;
                }
                
            }).catch( (error) => {
                console.error(error);
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else if(error.response.status == 422) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal mengambil data pribadi. [${error.message}]`
                    };
                }
                return error;
            });
        },

        getLinkDownload(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },

        provinsiChange() {
            this.form.kabkod = "";
            this.listKabKota = daerah.find(({provinsi}) => provinsi === this.form.provinsi).kabKota;            
        },

        validateFileKtp() {
            if (this.form.fileKtp !== "") return true;
            return this.form.uploadFileKtp != null || "Harap melampirkan scan KTP";
        },

        validateFileNpwp() {
            if (this.form.fileNpwp !== "") return true;
            return this.form.uploadFileNpwp != null || "Harap melampirkan scan NPWP";
        },

        validateFileFormulir() {
            if (this.form.fileFormulir !== "") return true;
            return this.form.uploadFileFormulir != null || "Harap melampirkan formulir";
        },

        submit() {
            if (!this.$refs.form.validate()) return;

            let fdata = new FormData();
            fdata.append("emailR", this.$store.getters.userInfo.email);
            fdata.append("vendorId", this.vendorId);
            fdata.append("nama", this.form.nama);
            fdata.append("alamat", this.form.alamat);
            fdata.append("provinsi", this.form.provinsi);
            fdata.append("kabkod", this.form.kabkod);
            fdata.append("kodepos", this.form.kodepos);
            fdata.append("telepon", this.form.telepon);
            fdata.append("email", this.form.email);
            fdata.append("noKtp", this.form.noKtp);
            fdata.append("npwp", this.form.npwp);
            fdata.append("fileKtp", this.form.uploadFileKtp);
            fdata.append("fileNpwp", this.form.uploadFileNpwp);
            fdata.append("fileFormulir", this.form.uploadFileFormulir);

            this.submitting = true;

            axios.post(`${apiUrl}/vendor/person/data-pribadi`, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
            .then( (response) => {
                //console.log("PersonDataPribadi.submit()-response: ", response.data);

                this.form.fileKtp = response.data.fileKtp;
                this.form.fileNpwp = response.data.fileNpwp;
                this.form.fileFormulir = response.data.fileFormulir;

                const storeVendor = {
                    id: response.data.id,
                    name: response.data.nama,
                    status: response.data.status
                };

                this.$store.dispatch('ven/assignVendor', storeVendor);

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Data pribadi berhasil disimpan"
                };

            }).catch( (error) => {
                console.error(error);
                if(error.response.status == 401) {
                    this.loginExpired = true;
                }else if(error.response.status == 422) {
                    this.loginExpired = true;
                }else {
                    this.notification = {
                        show: true,
                        color: "error",
                        text: `Gagal simpan data pribadi. [${error.message}]`
                    };
                }
                

            }).finally( () => {
                this.submitting = false;
            });

        },
        logoutClick: function() {
            this.$store.dispatch('logout')
            .then(() => {
                this.$router.push('/')
            })
        },

    }, // methods

}

</script>
